import { jsx as _jsx } from "react/jsx-runtime";
import { Thumb, Container, Track } from "./indicator.styles";
// utils
import { makeDataTestIdGetter } from "../../utils";
export const Indicator = ({ classes, show, dataTestIdPrefix, dark, }) => {
    const getDataTestId = makeDataTestIdGetter(dataTestIdPrefix);
    return (_jsx(Container, Object.assign({ show: show, "data-testid": getDataTestId("carousel-indicator") }, { children: _jsx(Track, Object.assign({ className: classes.track, dark: dark }, { children: _jsx(Thumb, { className: classes.thumb, dark: dark }) })) })));
};
